{/* Auto-generated icon - do not edit */}
import React from 'react'

interface GoogleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const GoogleIcon = React.forwardRef<SVGSVGElement, GoogleIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 173 169"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M162.043 76.775C160.881 76.6549 159.714 76.5951 158.546 76.5965C154.726 76.6463 150.907 76.6916 147.039 76.7369C135.124 76.8761 122.804 77.0204 110.687 77.3191C106.133 77.539 101.602 78.0962 97.1302 78.9875C93.7107 79.5874 91.7751 81.9161 92.0816 85.0658C92.3534 87.8677 94.3952 89.6779 97.5437 89.909C101.503 90.201 105.584 90.1564 109.099 90.0901C116.828 89.9444 124.555 89.7842 132.283 89.6103L133.767 89.5782C140.59 89.4298 147.412 89.2874 154.235 89.1509C155.482 89.1246 156.734 89.2047 158.319 89.3038L158.539 89.3176L159.778 89.3924C158.727 114.176 149.185 131.804 130.628 143.27C110.747 155.553 89.0992 160 66.2856 156.489C51.1847 154.163 39.0929 147.073 30.3459 135.413C18.5043 119.631 12.2467 102.499 11.7459 84.4929C10.9222 54.9347 25.004 32.0166 51.394 19.9603C61.5882 15.3049 70.2354 12.6705 78.609 11.6695C101.979 8.87551 120.888 14.3199 136.407 28.3222C136.57 28.4686 136.73 28.6208 136.922 28.8039C137.44 29.3307 138.01 29.8034 138.623 30.215C141.168 31.821 143.792 31.6216 145.823 29.6663C148.009 27.566 148.263 24.7003 146.472 22.3709C144.867 20.3364 142.991 18.5316 140.896 17.0068C127.847 7.20218 112.214 1.43003 95.9245 0.401573C72.7138 -1.16642 50.9084 5.26483 31.1034 19.5258C15.3513 30.8699 5.60788 46.8204 2.15095 66.9358C-1.27317 86.8557 2.04002 106.915 11.996 126.558C17.0229 136.473 22.6242 144.25 29.1206 150.335C41.7078 162.126 57.5249 168.081 77.4735 168.537C78.2487 168.554 79.0205 168.563 79.7956 168.563C94.2502 168.563 108.686 165.491 123.925 159.173C139.276 152.806 151.193 143.276 159.343 130.838C167.304 118.693 171.485 104.078 171.776 87.3998C171.911 79.7265 169.818 77.4412 162.043 76.775Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="171.961" height="168.679" fill={color} transform="translate(0.466064 0.078125)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

GoogleIcon.displayName = 'GoogleIcon'
